import { methods, request } from "./base";

const authApis = {
  loginPatient: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/login_or_register_patient",
      payload: data,
      priv: false,
    }),
  updateProfile: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/update_profile",
      payload: data?.payload,
      headers: data?.headers,
      priv: true,
    }),
  getPatientDetails: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/get_patient_details_v2",
      payload: data,
      priv: true,
    }),
};

export default authApis;
